import React, { useContext } from "react";
import { Bar } from "react-chartjs-2";
import domainService from "../../services/domainService";
import { darkerGrey, green } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";
import Chart from 'chart.js/auto';

const ServiceTypesGraph = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	const options = {
		indexAxis: "y",
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				ticks: {
					beginAtZero: true,
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			},
			y: {
				ticks: {
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			}
		},
		maintainAspectRatio: false
	};
	
	const getData = () => {		
		const keys = Object.keys(domainService.companyServiceTypes);
		let sortableList = [];
		for (let i in keys) {
			sortableList.push({ type: keys[i], total: domainService.companyServiceTypes[keys[i]] });
		}
		sortableList.sort((a, b) => { return b.total - a.total; });
		
		const labels = [];
		const counts = [];
		for (let i = 0; i < 5; i++) {
			if (sortableList.length <= i) continue;
			labels.push(sortableList[i].type);
			counts.push(sortableList[i].total);
		}
		
		const data = {
			labels: labels,
			datasets: [{
				label: "Services",
				backgroundColor: "#ff03ed",
				data: counts,
				fill: true,
			}]
		};
		
		return data;
	};
	
	return (
		<Bar data={getData()} options={options} width="100%" height="100%"/>
	);

}

export default ServiceTypesGraph;